import { useContext } from 'react';
import {
  HomefieldIconChevronRight,
  HomefieldIconLocationPinOutlinedNew,
} from '@dsg-tech/homefield-react-icons';
import { Skeleton } from '@dsg-tech/homefield-react';
import { handleADA } from '@dsg-tech/homefield-utils';
import { WindowContext } from 'utility/windowContext';
import { deliveryZipSelector } from 'store/selectors/locationServicesSelector';
import { useAppSelector } from 'store/store';
import useClientSideRender from 'hooks/useClientSideRender';
import './SameDayDelivery.scss';

interface SameDayDeliveryProps {
  viewPortBreakpoint: string;
  showInProgressiveTaxo?: boolean;
  setShowProgressiveTaxoDrawer?: () => void;
  showInMobileMenu?: boolean;
}

const SameDayDelivery = ({
  viewPortBreakpoint,
  showInProgressiveTaxo = false,
  setShowProgressiveTaxoDrawer = () => {},
  showInMobileMenu = false,
}: SameDayDeliveryProps) => {
  const deliveryZip = useAppSelector(deliveryZipSelector);
  const { isClient } = useClientSideRender();
  const win = useContext(WindowContext);

  const handleOpenSameDayDeliveryModal = () => {
    if (
      showInProgressiveTaxo &&
      setShowProgressiveTaxoDrawer &&
      (viewPortBreakpoint === 'desktop' || viewPortBreakpoint === 'small-desktop')
    ) {
      setShowProgressiveTaxoDrawer();
    }

    if (win && window?.headerFunctions?.sameDayDelivery) {
      window.headerFunctions.sameDayDelivery();
    }
  };

  const getClassNames = () => {
    const classNames = 'same-day-delivery-new hmf-align-items-center';

    if (showInProgressiveTaxo) {
      return `${classNames} store-locator-sdd-container hmf-display-flex hmf-py-xxs hmf-justify-content-between hmf-px-xxs`;
    }

    if (showInMobileMenu) {
      return `${classNames} mobile-menu hmf-p-s hmf-px-md-m hmf-display-flex hmf-justify-content-between`;
    }

    return `${classNames} hmf-py-lg-xxs hmf-display-none hmf-display-lg-flex hmf-pr-xxs hmf-pl-xxs`;
  };

  return (
    <button
      data-testid="same-day-delivery-new"
      className={getClassNames()}
      type="button"
      tabIndex={0}
      aria-label={`Zip Code for Same Day Delivery is ${isClient ? deliveryZip : 'still loading'}`}
      onClick={handleOpenSameDayDeliveryModal}
      onMouseDown={(e) => e.preventDefault()}
      onKeyDown={(e) => {
        handleADA(e, 'button', handleOpenSameDayDeliveryModal);
      }}>
      <div
        className={`hmf-display-flex hmf-text-align-left ${
          showInProgressiveTaxo ? 'hmf-flex-column hmf-pl-xxs' : 'hmf-align-items-center'
        }`}>
        {!showInProgressiveTaxo && <HomefieldIconLocationPinOutlinedNew width={24} height={24} />}
        {showInProgressiveTaxo && <div className="hmf-body-s">Deliver To</div>}
        <div
          className={`${
            showInProgressiveTaxo
              ? 'hmf-subheader-bold-m'
              : 'hmf-body-bold-l hmf-pl-xxs hmf-pr-xxxs'
          }`}>
          {isClient ? deliveryZip ?? <Skeleton /> : <Skeleton />}
          {!showInProgressiveTaxo && <div className="hmf-body-s">Delivery Location</div>}
        </div>
      </div>
      {showInProgressiveTaxo && <HomefieldIconChevronRight height="16px" width="16px" />}
      {showInMobileMenu && <HomefieldIconChevronRight height="24px" width="24px" />}
    </button>
  );
};

export default SameDayDelivery;
